import * as React from "react"

const ProblemSolver = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 277.5 197.6" {...props}>
    <title>{"about-problem-solver-3"}</title>
    <path
      d="M179.43 169.33h-78.88v-20a65.32 65.32 0 0 0-13.5-40.39 67.36 67.36 0 1 1 106 0 65.44 65.44 0 0 0-13.61 40.23Zm-63.88-15h48.88v-5.16a80.48 80.48 0 0 1 16.78-49.48 52.36 52.36 0 1 0-82.36 0 80.37 80.37 0 0 1 16.7 49.63ZM158.71 197.6h-37.27l-16.41-17h70.85l-17.17 17z"
      fill="#b9d816"
    />
    <path
      d="M33.11 75.77a11.73 11.73 0 1 0-11.74 11.72 11.75 11.75 0 0 0 11.74-11.72Zm-20.69 0a9 9 0 1 1 9 9 9 9 0 0 1-9-9ZM256.13 87.49a11.73 11.73 0 1 0-11.73-11.73 11.74 11.74 0 0 0 11.73 11.73Zm0-20.68a9 9 0 1 1-8.95 9 9 9 0 0 1 8.95-9Z"
      fill="#317d6e"
    />
    <path
      d="M236.95 85.03a21.33 21.33 0 1 0 0-18.49H40.56a21.33 21.33 0 1 0 0 18.49Zm19.18-25.53a16.29 16.29 0 1 1-16.28 16.3 16.31 16.31 0 0 1 16.28-16.29ZM5.05 75.77a16.29 16.29 0 1 1 16.33 16.26A16.29 16.29 0 0 1 5.05 75.77Z"
      fill="#317d6e"
    />
    <path
      fill="#4ead90"
      d="m138.68 108.91-28.89-16.68V58.87l28.89 16.68v33.36z"
    />
    <path
      fill="#317d6e"
      d="M167.57 58.87v33.36l-28.89 16.68V75.55l28.89-16.68z"
    />
    <path
      fill="#b9d816"
      d="m167.57 58.91-28.89-16.64-28.89 16.64 28.89 16.64 28.89-16.64z"
    />
  </svg>
)

export default ProblemSolver
